import { Box, HStack, Skeleton, SkeletonCircle, SkeletonText, VStack } from "@reverb-ui/react";

const isLoaded : boolean = false;

export const VisitorsFunnelSkeleton = () : JSX.Element => {
  return (
    <VStack
      bgColor="white"
      h="full"
      spacing={4}
      alignItems="start"
      pt={6}
      px={6}
      borderRadius="0.6rem"
    >
      <HStack width={"full"}>
        <SkeletonCircle isLoaded={isLoaded} variant="rect" width={5} height={5} />
        <SkeletonText isLoaded={isLoaded} variant="rect" noOfLines={1} width={"50%"} maxWidth={"13rem"} skeletonHeight={"1.2rem"} />
      </HStack>
      <HStack w="full" flex={1} spacing={4}>
        <VStack h="full" flex={1} alignItems="flex-end">
          {Array(4).fill(0).map((item, index) => (
            <Skeleton
              key={index}
              isLoaded={isLoaded} 
              variant="rect" 
              height={100 / index}
              minH={3}
              width={`${100 - index * 25}%`}
            />
          ))}
        </VStack>
        <VStack flex={1} h="full" alignItems="flex-start">
          {Array(4).fill(0).map((item, index) => (
            <Box pb={6} key={index}>
              <HStack pb={1} width={"10rem"}>
                <SkeletonText noOfLines={1} isLoaded={isLoaded} variant="rect" skeletonHeight={"1rem"} width={"30%"} />
                <SkeletonText noOfLines={1} isLoaded={isLoaded} variant="rect" skeletonHeight={"1rem"} width={"100%"} />
              </HStack>
              <SkeletonText noOfLines={1} isLoaded={isLoaded} variant="rect" skeletonHeight={"0.3rem"} width={"35%"} />
            </Box>
          ))}
        </VStack>
      </HStack>
    </VStack>
  );
};